import {
  PATCH_YADS_RECURRING_SCHEDULE_REQUEST,
  PATCH_YADS_RECURRING_SCHEDULE_SUCCESS,
  PATCH_YADS_RECURRING_SCHEDULE_FAILURE,
  PATCH_YADS_RECURRING_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

import { patchYadsRecurringSchedule } from '../../../Constants/apiService';

export const patchYadsRecurringScheduleRequest = () => ({ type: PATCH_YADS_RECURRING_SCHEDULE_REQUEST });
export const patchYadsRecurringScheduleSuccess = (data) => ({ type: PATCH_YADS_RECURRING_SCHEDULE_SUCCESS, payload: data });
export const patchYadsRecurringScheduleFailure = (err) => ({ type: PATCH_YADS_RECURRING_SCHEDULE_FAILURE, payload: err });
export const patchYadsRecurringScheduleReset   = () => ({ type: PATCH_YADS_RECURRING_SCHEDULE_RESET });

/**
 * taskId = scheduleId (e.g. "91e735cf-64df-4d2d-8e9e-15df63b218e5")
 * payload = your Edit Recurring payload (see above)
 */
export const editYadsRecurringSchedule = (taskId, payload) => {
  return async (dispatch, getState) => {
    dispatch(patchYadsRecurringScheduleRequest());
    const accessToken = getState().auth?.accessToken;

    try {
      const res = await patchYadsRecurringSchedule(taskId, payload, accessToken);
      dispatch(patchYadsRecurringScheduleSuccess(res));
    } catch (error) {
      const msg = error.message?.includes("fetch")
        ? "Unable to update schedule. Please try again."
        : error.message;
      dispatch(patchYadsRecurringScheduleFailure(msg));
    }
  };
};
